import { render, staticRenderFns } from "./StoresTab.vue?vue&type=template&id=335a8617&scoped=true&"
import script from "./StoresTab.vue?vue&type=script&lang=js&"
export * from "./StoresTab.vue?vue&type=script&lang=js&"
import style0 from "./StoresTab.vue?vue&type=style&index=0&id=335a8617&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "335a8617",
  null
  
)

export default component.exports
import {QForm,QScrollArea,QSelect,QInput} from 'quasar'
component.options.components = Object.assign(Object.create(component.options.components || null), component.options.components || {}, {QForm,QScrollArea,QSelect,QInput})
